import { render, staticRenderFns } from "./NewsTable.vue?vue&type=template&id=08dbf3bc"
import script from "./NewsTable.vue?vue&type=script&lang=js"
export * from "./NewsTable.vue?vue&type=script&lang=js"
import style0 from "./NewsTable.vue?vue&type=style&index=0&id=08dbf3bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports